import { useEffect, useState } from 'react';
import Layout from './Layout';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../client/client';
import { useLogin } from '../context/LoginContext';

const PasswordChangesForm = () => {
  const [loading, setLoading]                     = useState(true);
  const [error, setError]                         = useState(null);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const { getSessionAuth }                        = useLogin();
  const navigate                                  = useNavigate();

  const frequencyOptions = ['CADA 3 MESES', 'CADA 6 MESES', 'CADA AÑO'];

  useEffect(() => {
    const sessionAuth = async () => {
      const session = await getSessionAuth();
      if (session) {
        setLoading(false);
      } else {
        navigate("/", { replace: true });
      }
    };
    sessionAuth();
  }, []);

  const [formData, setFormData] = useState({
    date_change:      '',
    date_next_change: '',
    frequency:        'CADA 3 MESES',
  });

  const [equiposList, setEquiposList]       = useState([]);
  const [selectedEquipo, setSelectedEquipo] = useState(null);

  useEffect(() => {
    const fetchEquipos = async () => {
      try {
        const { data, error } = await supabase
          .from('equipos')
          .select('id, title, attendant')
          .or(
            "area.eq.ARBITRAJE," +
            "area.eq.TECNOLOGIA DE INFORMACION," +
            "attendant.eq.SALOMÉ GALDOS," +
            "attendant.eq.KATHERINE SUEROS," +
            "attendant.eq.RUTH VARGAS"
          )
          .order('attendant', { ascending: true });
        if (error) throw error;
        setEquiposList(data);
      } catch (e) {
        console.error('Error fetching equipos:', e.message);
      }
    };
    fetchEquipos();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEquipoChange = (e) => {
    const found = equiposList.find((eq) => eq.id === e.target.value) || null;
    setSelectedEquipo(found);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!selectedEquipo) {
      setError('Por favor selecciona un equipo.');
      return;
    }
    if (!formData.date_change || !formData.date_next_change) {
      setError('Por favor completa las fechas.');
      return;
    }

    try {
      const { error: dbError } = await supabase.from('password_changes').insert([
        {
          id_equipo:        selectedEquipo.id,
          equipo_title:     selectedEquipo.title,
          equipo_attendant: selectedEquipo.attendant,
          date_change:      formData.date_change,
          date_next_change: formData.date_next_change,
          frequency:        formData.frequency,
        },
      ]);

      if (dbError) {
        setError('Error al guardar el cambio de contraseña.');
      } else {
        setShowSuccessDialog(true);
      }
    } catch (e) {
      setError('Error inesperado al guardar.');
    }
  };

  const handleAccept = () => {
    setShowSuccessDialog(false);
    navigate("/equipos");
  };

  return (
    <Layout>
      <form onSubmit={handleSubmit}>
        <h1 className='text-3xl font-bold text-[#4691A6] flex justify-center pb-10'>
          CAMBIO DE CONTRASEÑAS
        </h1>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6">
            {error}
          </div>
        )}

        <div className="form-row">
          <div className="field">
            <label className='text-xs font-semibold'>
              Equipo:
              <select name="equipo" value={selectedEquipo?.id || ''} onChange={handleEquipoChange}>
                <option value="" disabled>Selecciona un equipo</option>
                {equiposList.map((equipo) => (
                  <option key={equipo.id} value={equipo.id}>
                    {equipo.title} — {equipo.attendant}
                  </option>
                ))}
              </select>
            </label>
          </div>
        </div>

        <div className="form-row">
          <div className="field">
            <label className='text-xs font-semibold'>
              Fecha del cambio:
              <input
                type="date"
                name="date_change"
                value={formData.date_change}
                onChange={handleChange}
              />
            </label>
          </div>
          <div className="field">
            <label className='text-xs font-semibold'>
              Fecha del próximo cambio:
              <input
                type="date"
                name="date_next_change"
                value={formData.date_next_change}
                onChange={handleChange}
              />
            </label>
          </div>
          <div className="field">
            <label className='text-xs font-semibold'>
              Frecuencia:
              <div className="styled-select">
                <select
                  name="frequency"
                  value={formData.frequency}
                  onChange={handleChange}
                  className="styled-select"
                >
                  {frequencyOptions.map((option) => (
                    <option key={option} value={option}>{option}</option>
                  ))}
                </select>
              </div>
            </label>
          </div>
        </div>

        <div className="form-row">
          <button
            className="bg-[#356674] hover:bg-[#4691A6] transition-colors duration-300 text-base cursor-pointer mt-7 text-white font-semibold py-2 px-4 rounded-md w-full"
            type="submit"
          >
            Guardar
          </button>
        </div>

        {showSuccessDialog && (
          <div className="success-dialog">
            <p>Se ha guardado exitosamente</p>
            <button
              onClick={handleAccept}
              className="bg-[#356674] hover:bg-[#4691A6] transition-colors duration-300 text-base cursor-pointer mt-7 text-white font-semibold py-2 px-4 rounded-md w-full"
            >
              Aceptar
            </button>
          </div>
        )}
      </form>
    </Layout>
  );
};

export default PasswordChangesForm;
